import { useEffect, useState } from "react";

// Standard Mantine breakpoints or custom ones
const breakpoints = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1024,
  xl: 1400,
};

export default function useWindowSize() {
  const size = useWindowSizes();

  return {
    size,
    isMobile: size.width ? size.width < breakpoints.sm : false,
    isTablet: size.width
      ? size.width >= breakpoints.sm && size.width < breakpoints.lg
      : false,
    isLaptop: size.width
      ? size.width >= breakpoints.lg && size.width < breakpoints.xl
      : false,
    isDesktop: size.width ? size.width >= breakpoints.lg : false,
    aboveTablet: size.width ? size.width >= breakpoints.lg : false,
    xs: breakpoints.xs,
    sm: breakpoints.sm,
    md: breakpoints.md,
  };
}

function useWindowSizes() {
  const [windowSize, setWindowSize] = useState<{
    width: number | undefined;
    height: number | undefined;
  }>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };

      window.addEventListener("resize", handleResize);
      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return windowSize;
}
